// @flow
import React, { type Node, Component } from 'react';
import {
  SimpleLayoutDiv,
  SimpleLayoutFooterH4,
  SimpleContentDiv,
  SimpleLogoImg
} from './LayoutStyles';
import netcents from '../../assets/images/logo-netcents.png';

type Props = {
  children: Node
};

export default class SimpleLayout extends Component<Props> {
  render() {
    return (
      <SimpleLayoutDiv>
        <SimpleLogoImg src={netcents} />
        <SimpleContentDiv>{this.props.children}</SimpleContentDiv>
        <SimpleLayoutFooterH4>
          &copy; NetCents Technology Inc.
        </SimpleLayoutFooterH4>
      </SimpleLayoutDiv>
    );
  }
}
